/**
 * TEMP Local type until the actual type is defined in the MCL
 * @typedef {Object} TEMPSelectedPrice
 * @property {number} [priceTypeId]
 * @property {Object} [lowestSalePriceTier]
 * @property {Array<Record<string, any>>} [lowestSalePriceTier.values]
 * @property {Array<Record<string, any>>} [tieredPrice]
 */

/**
 * @param {TEMPSelectedPrice} selectedPrice
 * @returns {number | undefined}
 */
export const getOriginalPrice = (selectedPrice) => {
  const { tieredPrice } = selectedPrice || {};
  return tieredPrice?.[0]?.values?.[0]?.value || undefined;
};

/**
 * @param {TEMPSelectedPrice} selectedPrice
 * @returns {number | undefined}
 */
export const getLowestPrice = (selectedPrice) => {
  const originalPrice = getOriginalPrice(selectedPrice);

  const { lowestSalePriceTier } = selectedPrice || {};
  return lowestSalePriceTier?.values?.[0]?.value || originalPrice;
};
